module.exports = __webpack_public_path__ + "static/img/lingdaima.bcda4a8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/lingdaima.gif
// module id = e5+T
// module chunks = 0